import React, { lazy, Suspense } from 'react';
import type { PostProcessingEffectsProps } from './PostProcessingEffects.js';

const LazyEffects = lazy(() =>
  import('./PostProcessingEffects.js').then((m) => ({ default: m.PostProcessingEffects })),
);

export const ScenePostProcessing: React.FC<PostProcessingEffectsProps> = (props) => {
  if (!props.ssao && !props.bloom) return null;

  return (
    <Suspense fallback={null}>
      <LazyEffects {...props} />
    </Suspense>
  );
};
